import 'core-js/stable'
import Vue from 'vue'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import App from '@/App'
import router from '@/router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import VeeValidate from 'vee-validate';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import vSelect from "vue-select";
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard)

Vue.component("v-select", vSelect);
import Paginate from 'vuejs-paginate';
Vue.component('paginate', Paginate)

import AssetSelector from '@/components/AssetSelector.vue';
Vue.component('asset-selector', AssetSelector);

import Search from '@/components/Search.vue';
Vue.component('search', Search);

import ListingActions from '@/components/AddDeleteButtons.vue';
Vue.component('listing-action', ListingActions);

import InvoicePortalLink from '@/components/Sidebar/InvoicePortalLink.vue';
Vue.component('InvoicePortalLink', InvoicePortalLink);

import * as lucide from 'lucide-vue'

// Register each icon globally
Object.entries(lucide).forEach(([name, component]) => {
  Vue.component(name, component as any)
})

import myMixins from '@/mixins/myMixins';
Vue.mixin(myMixins)

import preservePagination from '@/mixins/preservePagination';
Vue.mixin(preservePagination)

import VModal from 'vue-js-modal'
import 'vue-js-modal/dist/styles.css'
Vue.use(VModal, {})

import ZoomOnHover from "vue-zoom-on-hover";
Vue.use(ZoomOnHover);

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
Vue.use(IconsPlugin)
// Vue.config.performance = true
Vue.config.productionTip = false
Vue.use(CoreuiVue)
Vue.use(VeeValidate, { fieldsBagName: 'veeFields' });
Vue.use(VueToast);

Vue.directive('visible', function(el, binding) {
    el.style.visibility = !binding.value ? 'hidden' : 'visible';
});

import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert);

import { can, setPageTitle } from "@/helpers/Helpers"
Vue.prototype.$log = console.log.bind(console)
Vue.prototype.$can = can

import VueMoment  from 'vue-moment'

Vue.use(VueMoment)

new Vue({
    router,
    store,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    icons,
    render: h => h(App)
}).$mount("#app");


